import { render, staticRenderFns } from "./Ylayer.vue?vue&type=template&id=6cc59c06&scoped=true"
import script from "./Ylayer.vue?vue&type=script&lang=js"
export * from "./Ylayer.vue?vue&type=script&lang=js"
import style0 from "./Ylayer.vue?vue&type=style&index=0&id=6cc59c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc59c06",
  null
  
)

export default component.exports